import requst from './request';

// 获取顶部菜单栏数据
export const getSiteFirstMenu = (data) =>
requst.post("/cmsapi/getSiteFirstMenu", { ...data });
